import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const AuthContext = createContext();

export function AuthWrapper({ children }) {
    const [user, setUser] = useState(null);
    const [status, setStatus] = useState("loading"); // loading | authed | anon

    async function refreshAuth() {
        try {
            const res = await fetch(
                `${import.meta.env.VITE_API_BASE_URL}/auth/me`,
                { credentials: "include" }
            );
            if (!res.ok) throw new Error("unauthenticated");
            const data = await res.json();
            if (data.success) {
                setUser(data.user);
                setStatus("authed");
            } else {
                setUser(null);
                setStatus("anon");
            }
        } catch {
            setUser(null);
            setStatus("anon");
        }
    }

    useEffect(() => {
        refreshAuth();
    }, []);

    const isAdmin = status === "authed" && user?.role === "ADMIN";

    return (
        <AuthContext.Provider value={{ user, status, isAdmin, refreshAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}

// Backstage is ADMIN-only by design (Google SSO, domain-restricted). The
// external sales agency works on sales.bidlyzer.com instead — same API,
// SALES-role password login, none of the admin surfaces.
export function RequireAdmin({ children }) {
    const { status, isAdmin } = useAuth();
    const location = useLocation();

    if (status === "loading") return <div>Loading...</div>;
    if (!isAdmin) return <Navigate to="/login" replace state={{ from: location }} />;
    return children;
}
